export default "__VITE_ASSET__DcTifi8B__"